<div class="about-area latest-talent bg-ffffff pb-100 mb-100" *ngIf="talent">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="episode-image">
            <a [href]="talent.youtube_link" target="_blank">
              <img [src]="talent.thumbnail?.data?.attributes.url || 'assets/images/latent-1.png'" alt="Talent image">
            </a>
            <div class="video-view">
              <a
                [href]="talent.video_link"
                target="_blank"
                class="popup-youtube"
              >
                <i class="ri-play-mini-fill"></i>
              </a>
            </div>
          </div>
        </div>
  
        <div class="col-lg-6 col-md-12">
          <div class="about-content-wrap with-another-color mt-4">
            <h3 class="mb-1">AfroTech Talents</h3>
            <p class="lead text-muted fw-medium" style="font-style: italic; font-size: 1.1rem;">
              À la rencontre des créateurs de demain !
            </p>
  
            <div class="text-center my-3">
              <blockquote class="blockquote mx-auto px-3 py-2" 
                style="max-width: 500px; background-color: #f8f9fa; border-left: 4px solid #f37529; border-radius: 0.5rem; font-size: 0.9rem;">
                <p class="mb-1 fst-italic text-muted" style="font-size: 0.92rem;">
                  “{{talent.quote}}”
                </p>
                <footer class="blockquote-footer mt-2">{{talent.talent_name}}</footer>
              </blockquote>
            </div>                                       
  
            <p class="mt-4">{{talent.content}}</p>
  
            <div class="text-center mt-4">
              <a 
                [href]="talent.youtube_link"
                class="default-btn"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <i class="flaticon-play-button mr-2"></i> Découvrez le talent
              </a>
            </div>            
  
            <ul class="about-social">
              <li *ngIf="talent.facebook_link"><a [href]="talent.facebook_link" target="_blank"><i class="flaticon-facebook"></i></a></li>
              <li *ngIf="talent.linkedin_link"><a [href]="talent.linkedin_link" target="_blank"><i class="ri-linkedin-fill"></i></a></li>
              <li *ngIf="talent.instagram_link"><a [href]="talent.instagram_link" target="_blank"><i class="flaticon-instagram"></i></a></li>
            </ul>
  
            <div class="browse-all-btn black-color">
              <a routerLink="/afrotech-talents">Découvrez tous nos talents <i class="ri-arrow-right-s-line"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  